import { IRawFileRecord } from "@/typings/file";

export const hasSourceFile = (fileRecord: IRawFileRecord) => {
  return Boolean(Object.values(fileRecord.files).find(file => file?.isMaster));
};
